import { getFeatureValueFn } from '../lib/features';
import { useIdentityStore } from '../lib/store';

export function useFeatureFlag(flags: string): boolean;
export function useFeatureFlag(flags: string[]): boolean[];
export function useFeatureFlag(flags: string | string[]): boolean | boolean[];
export function useFeatureFlag(flags: string | string[]) {
	const client = useIdentityStore((state) => state.experimentClient);

	const getFeatureValue = getFeatureValueFn(client);

	if (Array.isArray(flags)) {
		return flags.map(getFeatureValue);
	}

	return getFeatureValue(flags);
}
